import { render, staticRenderFns } from "./SalesToDeliver.vue?vue&type=template&id=255f76e3"
import script from "./SalesToDeliver.vue?vue&type=script&lang=ts"
export * from "./SalesToDeliver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports